export default "__VITE_ASSET__Div8clZx__"